import AlertSystemModal from "./alert-system-modal.component";

export default AlertSystemModal;
